/**
 * First-load experience: the Echo mark flows continuously through its trail
 * while the screen waits with an honest indeterminate status. No fabricated
 * percentage, particles, scanlines, moving grids, nested frames, or
 * "INITIALIZING" theater - see EchoBrandMark for the motion contract.
 */

import React from 'react';
import './LoadingScreen.css';
import EchoBrandMark from './EchoBrandMark';

const LoadingScreen = ({ isExiting = false, brandingStatus = 'ready', dojoLogoUrl = null, dojoName = '' }) => {
  return (
    <div className={`loading-screen ${isExiting ? 'exiting' : ''}`}>
      <main className="loading-content">
        {brandingStatus === 'ready' && (dojoLogoUrl
          ? <img className="loading-dojo-logo" src={dojoLogoUrl} alt={`${dojoName || 'Dojo'} logo`} />
          : <EchoBrandMark className="loading-logo loading-logo-tick" decorative animate={false} tickTrail />)}
        <div className="loading-brand" aria-hidden="true">
          <span>KATA</span><b>.</b><span>FIT</span>
        </div>
        <p className="loading-status" role="status" aria-live="polite">Loading&hellip;</p>
      </main>
    </div>
  );
};

export default LoadingScreen;
